export const cleanSearchQuery = (query) => query === null || query === void 0 ? void 0 : query.trim().replace(/[-+()"']/gi, ' ');
//# sourceMappingURL=search.js.map